import { createFileRoute, redirect } from '@tanstack/react-router'

import { ProfilePage } from '@/shared/auth/components/ProfilePage'
import { meQueryOptions } from '@/shared/auth/hooks/useGetMe'
import { postLoginRedirect } from '@/shared/auth/post-login-redirect'
import { useAuthStore } from '@/shared/auth/stores/authStore'

interface ProfileSearch {
  // Optional deep-link from the header dropdown's "Change password" item.
  // ProfilePage scrolls to + highlights the change-password card when set.
  action?: 'change-password' | undefined
}

// Self-profile page. Available to any authenticated role — admin /
// super_admin / HOD reach it via the avatar dropdown; FOs
// would be redirected to /mobile-only by the role-aware guards before
// they could ever click the link.
export const Route = createFileRoute('/profile')({
  beforeLoad: () => {
    const state = useAuthStore.getState()
    if (!state.isAuthenticated) {
      throw redirect({ to: '/login' })
    }
    const role = state.user?.role_name
    if (role === 'field_officer') {
      throw redirect({ to: postLoginRedirect(role) })
    }
  },
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(meQueryOptions())
  },
  validateSearch: (search: Record<string, unknown>): ProfileSearch => ({
    action: search['action'] === 'change-password' ? 'change-password' : undefined,
  }),
  component: ProfilePage,
})
